<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Detail Promo</h5>
            </template>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">DATA PROMO</h6>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Nama Promo</b-col>
                    <b-col>{{ promo.name }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Tipe Pinjaman</b-col>
                    <b-col>{{ promo.jenisPinjaman.name }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Jenis Barang</b-col>
                    <b-col v-if="promo.jenisBarang.name != null">{{ promo.jenisBarang.name }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Merk Barang</b-col>
                    <b-col v-if="promo.merk.name != null">{{ promo.merk.name }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Tipe Barang</b-col>
                    <b-col v-if="promo.tipe.name != null">{{ promo.tipe.name }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Cabang</b-col>
                    <b-col>{{ promo.jumlahCabang }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Mulai Promo</b-col>
                    <b-col><div>{{$helper.changeDateFormat(promo.start)}}</div></b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Selesai Promo</b-col>
                    <b-col><div>{{$helper.changeDateFormat(promo.end)}}</div></b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Nominal</b-col>
                    <b-col v-if="promo.persen == null">
                        <div>Rp. {{$helper.addThousandSeparator(promo.nominal)}}</div>
                    </b-col>
                    <b-col v-else>
                        <div>{{$helper.addThousandSeparator(promo.persen)}}%</div>
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Minimal Harga Barang</b-col>
                    <b-col v-if="promo.hargaBarangMinimal == 0">
                        <div>Rp. 0</div>
                    </b-col>
                    <b-col v-else>
                        <div>Rp. {{$helper.addThousandSeparator(promo.hargaBarangMinimal)}}</div>
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Maksimal Harga Barang</b-col>
                    <b-col>
                        <div>Rp. {{$helper.addThousandSeparator(promo.hargaBarangMaksimal)}}</div>
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Status</b-col>
                    <b-col v-if="promo.status == 0">Pending</b-col>
                    <b-col v-else-if="promo.status == 1">Sedang Berjalan</b-col>
                    <b-col v-else>Selesai</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Keterangan</b-col>
                    <b-col>{{ promo.keterangan }}</b-col>
                </b-row>
            </div>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">DATA CABANG</h6>
                <ul v-for="(item, idx) in promo.cabang" v-bind:key="idx" class="list-circle-wrapper">
                    <li>{{ item.name }}</li>
                </ul>
            </div>
            <div class="detail-edit-btn">
                <b-button variant="pgiBtn" name="promoEditBtn" @click="editPromo">Edit</b-button>
            </div>
        </b-card>
    </div>
</template>

<script>
export default {
    name: 'detail-promo',
    data(){
        return{
            id: null,
            initStatus: 0,
            promo: []
        }
    }, 
    methods:{

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.id = this.$route.params.id

            let getSinglePromo = this.$axios.get(`promo/${this.id}`).then(response => {
                this.promo = response.data

                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            Promise.all([getSinglePromo]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },


        //----------------- Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },
        editPromo(){
            this.$router.push({
                path: `${this.$route.path}/edit`
            })
        }
    },

    created(){
        this.init()
    }
}
</script>
